import React, { useContext } from 'react'
import { TransactionDto } from 'api/Transaction/Types/Transaction'
import { successToast, ToastContext } from 'components/Toast/Toast'
import { useApiClient } from 'utils/api/ApiClient'
import { WalletsApiClient } from 'utils/api/walletsApiClient'

import { TransactionReverseForm, TransactionReverseFormValues } from './TransactionReverseForm'

interface TransactionReverseProps {
  transaction: TransactionDto

  onClose(): void
}

export const useTransactionReverseForm = (
  props: TransactionReverseProps
): {
  onSubmit: (values: TransactionReverseFormValues) => Promise<void>
} => {
  const setToast = useContext(ToastContext)
  const walletsApiClient = useApiClient(WalletsApiClient)

  const onSubmit = async (values: TransactionReverseFormValues) => {
    await walletsApiClient.reverseCompletedTransaction({
      transactionId: props.transaction.id,
      comment: values.comment,
    })
    setToast(successToast('Transaction reversed.'))
    await props.onClose()
  }

  return { onSubmit }
}

const TransactionReversePage: React.FC<TransactionReverseProps> = (props) => {
  const { onSubmit } = useTransactionReverseForm(props)
  return <TransactionReverseForm transaction={props.transaction} onSubmit={onSubmit} />
}

export default TransactionReversePage
